import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const options = {
    position: toast.POSITION.BOTTOM_RIGHT,
    hideProgressBar: true,
};

toast.configure(options);

export { toast };
